<template>
  <div>
    <main-header></main-header>
    <div id="custom-header" class="ourStrnegth" ref="ourStrnegth">
      <img src="../assets/images/banner/img_banner2.jpg" />
      <div class="custom-header-content">
        <div class="container">
          <h1 class="page-title">Our Strength</h1>
        </div>
      </div>
    </div>
    <div id="content" class="site-content global-layout-no-sidebar">
      <div class="container">
        <div class="inner-wrapper">
          <div id="primary" class="content-area">
            <div id="main" class="site-main">
              <!-- About the Factory -->
              <div class="section section-services">
                <div class="container">
                  <div class="section-title-wrap">
                    <h2 class="section-title">About the Factory</h2>
                    <span class="divider"></span>
                  </div>
                  <div>
                    <div class="col-grid-5">
                      <div class="line_border"></div>
                      <div class="border_img">
                        <img
                          alt="About Us"
                          src="../assets/images/ourStrength/img_fact.png"
                        />
                      </div>
                    </div>
                    <div class="col-grid-7">
                      <div class="featured-page-section">
                        <p>
                          ZhongShan Xin Qi Dian Co.,Ltd. was established 
                          in Beijing in 2006 but moved to ZhongShan 
                          in 2025 due to business expansion. We have
                          introduced a whole set of cutting-edged production
                          line of international level for high end furniture,
                          which includes mill work, integral kitchen and bath
                          facility etc. we commit ourselves to build a
                          production center of advance building materials,
                          design and development center, show center and a
                          logistic and customer service center. In order to
                          adapt to new trends, we pursue to restructure our
                          company and set up ZhongShan Xin Qi Dian Co., Ltd. 
                          in December, 2026. As China first class producer 
                          of custom made built-in furniture, Xin Qi Dian
                          is a model of combination European modern
                          industrial technology with traditional handicrafts.
                        </p>
                        <p>
                          With unremitting endeavor of all staff, our company
                          has developed from a millwork plant into a furniture
                          manufacturer specializing in offering supporting
                          service for high level decoration. The new technology,
                          which includes the most advanced full set production
                          line introduced from Germany, overthrows traditional
                          pattern of furniture producing and processing by
                          turning it into “components and parts assembly” under
                          informationized control system, realizing the
                          scientific and intelligent production. Meanwhile, in
                          order to meet the demands for whole-room customized in
                          furniture market and forge a 4.0 industry, we have
                          independently designed and assembled our own unmanned
                          and full automatic production line. We will become the
                          first company applying unmanned technology in board
                          furniture manufacture.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Our Innovation -->
              <div class="section section-services lite-background">
                <div class="container">
                  <div class="section-title-wrap">
                    <h2 class="section-title">Our Innovation</h2>
                    <span class="divider"></span>
                  </div>
                  <div class="service-block-list">
                    <div>
                      <div class="col-grid-8">
                        <div class="featured-page-section">
                          <p>
                            We still make high investment in scientific and
                            technological innovation, production R&D and
                            high-tech equipment. By combining many years'
                            experience of production and referring to multiple
                            kinds of projects at home and abroad, our excellent
                            scientific and technical personnel have made many
                            patents and technical breakthrough in design,
                            technology, equipment automation, etc. including
                            electronic chip component implant technology, flap
                            technique of 45 degree on the finishing coat
                            finished, new door inner keel, multi-functional
                            hotel wardrobe, new acoustical panel with LED, new
                            glue sprayer, etc.
                          </p>
                          <p>
                            We have made breakthrough by combination of
                            full-automatic coating process and special-shaped
                            process. With improved equipment and coating
                            process, special-shaped component with various
                            angles can be realized on the finished coat panel
                            directly, which not only make the exposed corner
                            edge in excellent quality, but also save cost and
                            improve manufacture efficiency.
                          </p>
                          <div class="featured-page-item">
                            <p>• Acoustic panel patent technology</p>
                            <p>• New pulp shooting machine patent technology</p>
                          </div>
                        </div>
                      </div>
                      <div class="col-grid-4">
                        <img
                          alt="About Us"
                          class="alignnone"
                          src="../assets/images/ourStrength/img_factory1.png"
                        />
                        <img
                          class="alignnone"
                          alt="About Us"
                          src="../assets/images/ourStrength/img_factory2.png"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="section section-testimonial button-circle-enabled background-img overlay-enabled"
              >
                <div class="container">
                  <div class="section-title-wrap">
                    <h2 class="section-title">
                      Qualification & Copyright Registration
                    </h2>
                    <span class="divider"></span>
                  </div>
                  <div class="swiper">
                    <swiper :options="swiperOption" ref="mySwiper">
                      <swiper-slide
                        v-for="(item, index) of honorList"
                        :key="index"
                      >
                        <div class="slider_bg" @click="clickImg(item)">
                          <img :src="item" />
                        </div>
                      </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev" slot="button-prev">
                      <i class="fa fa-angle-left" aria-hidden="true"></i>
                    </div>
                    <div class="swiper-button-next" slot="button-next">
                      <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <main-foot></main-foot>
    <PageScroller></PageScroller>
    <PicImage
      :imgUrl="imgurl"
      :imgShow="imgShow"
      @closeimg="imgClose"
    ></PicImage>
  </div>
</template>

<script>
import MainHeader from "../components/MainHeader";
import MainFoot from "../components//MainFoot";
import PageScroller from "../components/PageScroller";
import PicImage from "../components/PicImage";
const images = [
  require("../assets/images/ourStrength/copyright1.jpg"),
  require("../assets/images/ourStrength/copyright2.jpg"),
  require("../assets/images/ourStrength/copyright3.jpg"),
  require("../assets/images/ourStrength/copyright4.jpg"),
  require("../assets/images/ourStrength/copyright5.jpg"),
  require("../assets/images/ourStrength/copyright6.jpg"),
  require("../assets/images/ourStrength/patent1.jpg"),
  require("../assets/images/ourStrength/patent2.jpg"),
];
export default {
  name: "OurStrength",
  created() {
    let self = this;
  },
  data() {
    return {
      imgShow: false,
      imgurl: "",
      honorList: images,
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        observer: true,
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        loop: true,
        slidesPerView: 3,
        spaceBetween: 30,
      },
      //screenWidth: document.body.clientWidth,
    };
  },
  methods: {
    clickImg(val) {
      this.imgShow = true;
      this.imgurl = val;
    },
    imgClose() {
      this.imgShow = false;
    },
  },
  components: { MainHeader, MainFoot, PageScroller, PicImage },
};
</script>

<style lang="less"  scoped>
.col-grid-5 {
  position: relative;
  .line_border {
    width: 396px;
    height: 440px;
    border: 4px solid #0095dd;
    position: absolute;
    top: 31px;
  }
  .border_img {
    position: absolute;
    left: 73px;
    top: 0;
  }
}

.swiper {
  margin-top: 40px;
  position: relative;
  margin-bottom: 230px;
  //height: 363px;
  .slider_bg {
    background: #ffffff;
    padding: 20px 58px;
    height: 363px;
  }
  .swiper-button-prev,
  .swiper-button-next {
    border-radius: 50%;
    background-color: #ffffff;
    outline: none;
    color: #000;
    cursor: pointer;
    display: block;
    font-weight: normal;
    line-height: 0.8;
    padding-top: 5px;
    position: absolute;
    text-align: center;
    top: 45%;
    z-index: 9;
    font-size: 17px;
    padding: 16px 20px;
    background: #ffffff;
    box-shadow: 0 0 40px #2422224a;
    &:hover {
      color: #ffffff;
      background-color: red;
    }
  }

  .swiper-button-prev {
    left: -25px;
  }

  .swiper-button-next {
    right: -25px;
  }
}

.swiper-slide img {
  width: 100%;
  height: 100%;
}
.col-grid-4 {
  img {
    margin-bottom: 10px;
  }
}
.featured-page-item {
  margin-top: 55px;
  p {
    margin: 0 0 10px 0;
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    color: #272727;
    line-height: 1.5;
  }
}
</style>
